import React from "react";

function Aboutus() {
  return (
    <>
      <div class="mt-20 max-w-3xl mx-auto py-8 AboutSection">
        <h1 class="text-3xl font-bold mb-4">Get to know us</h1>
        <p class="mb-4">
          CurioCode Solution is an IT services and IT consultancy firm
          specializing in crafting innovative solutions for businesses. We are
          deeply passionate about technology and firmly believe in the
          transformative power of software. Our internship program exemplifies
          our commitment to nurturing the future talent of the industry.
        </p>
        <p class="mb-8">
          At CodSoft, we believe practical knowledge is the key to success in
          the tech industry. Our aim is to help students lacking basic skills by
          offering hands-on learning through live projects and real-world
          examples. Our team consists of industry experts who are dedicated to
          equipping interns with the knowledge and skills needed to succeed in
          their careers. We foster an inclusive and supportive environment that
          encourages learning, growth, and creativity.
        </p>

        <h1 class="text-3xl font-bold mb-4">Our Mission</h1>
        <p class="mb-8">
          Software development is an iterative process, and the mission includes
          continually improving software solutions. This entails gathering
          feedback, identifying areas for enhancement, and implementing updates
          to make the software more efficient, user-friendly, and reliable.
          Continuous improvement also involves staying up to date with the
          latest technologies, tools, and industry trends.
        </p>

        <h1 class="text-3xl font-bold mb-4">Our Vision</h1>
        <p>
          The vision of software development is to create innovative solutions
          that push the boundaries of technology. This involves leveraging
          emerging technologies, exploring new ideas, and developing software
          that brings novel approaches to solving problems and improving the
          lives of users.
        </p>
      </div>
    </>
  );
}

export default Aboutus;
